export enum FileUploadStatus {
  Pending = 0,
  Processing = 1,
  Completed = 2,
  Failed = 3,
}

/** @deprecated Use FileUploadStatus */
export { FileUploadStatus as NotificationStatus };

/**
 * Notification DTO returned by GET /api/Notification/unread.
 */
export interface JobNotificationDto {
  id: number;
  fileUploadJobId: number;
  isRead: boolean;
  createdOn: string;
  fileName: string;
  jobType: string;
  status: FileUploadStatus;
  errorMessage?: string;
  totalRows?: number;
  successfulRows?: number;
  failedRows?: number;
  completedOn?: string;
}

/** @deprecated Use JobNotificationDto */
export type INotification = JobNotificationDto;

export default JobNotificationDto;

/**
 * Job history DTO returned by GET /api/WkldSheetData/jobs.
 */
export interface FileUploadJobDto {
  id: number;
  fileName: string;
  jobType: string;
  status: FileUploadStatus;
  errorMessage?: string;
  totalRows?: number;
  successfulRows?: number;
  failedRows?: number;
  createdOn: string;
  startedOn?: string;
  completedOn?: string;
  projectId?: number;
  isDownloadReady?: boolean;
}

/**
 * Transaction log item DTO returned by GET /api/Workload/transaction-log.
 */
export interface TransactionLogItemDto {
  id: number;
  fileName: string;
  jobType: string;
  projectId?: number;
  status: FileUploadStatus;
  isDownloadReady?: boolean;
  errorMessage?: string;
  totalRows?: number;
  successfulRows?: number;
  failedRows?: number;
  createdOn: string;
  startedOn?: string;
  completedOn?: string;
  userFullName?: string;
  module?: string;
  action?: string;
  durationSeconds?: number;
}

/**
 * Paged response wrapper for GET /api/Workload/transaction-log.
 */
export interface TransactionLogPagedDto {
  data: TransactionLogItemDto[];
  currentPage: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export interface TransactionLogFilters {
  pageNumber: number;
  pageSize: number;
  searchTerm?: string;
  statuses?: number[];
  modules?: string[];
}

/**
 * Status option DTO returned by GET /api/Workload/transaction-log/statuses.
 */
export interface TransactionLogStatusOptionDto {
  id: number;
  name: string;
}
